import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpEventType, HttpErrorResponse } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { of } from 'rxjs';
import { ContenedoresService } from './../../../../../../../../../services/API/contenedores/contenedores.service';
import { NotificationServiceService } from './../../../../../../../../../services/notification-service/notification-service.service';

@Component({
    selector: 'app-upload-images',
    templateUrl: './upload-images.component.html',
    styleUrls: ['./upload-images.component.css'],
    standalone: false
})
export class UploadImagesComponent implements OnInit {

  files: File[] = [];
  path: string = "";
  tipo: string = "";
  id: number = null;
  toUpload: number = 0;
  uploaded: number = 0;
  maxImages: number = 999;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, private contenedoresService: ContenedoresService, private notificationService: NotificationServiceService, private dialogRef: MatDialogRef<UploadImagesComponent>) { }

  ngOnInit(): void {
    this.path = this.data['path'];
    this.id = this.data['id'];
    this.tipo = this.data['tipo'];
    this.maxImages = parseInt(this.data['maxImages']);
    //console.log(this.path);
  }

  onSelect(event: any) {
    //console.log(event);
    this.files.push(...event.addedFiles);
  }

  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  save() {
    this.toUpload = this.files.length;
    if(this.toUpload <= this.maxImages){
      for (var i = 0; i < this.files.length; i++) {
        this.uploadFile(this.files[i]);
      }
    }else{
      this.notificationService.openSnackBar("❌ Error: Limite de "+this.maxImages+" a la vez.");
    }
  }

  close() {
    this.dialogRef.close();
  }

  uploadFile(file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('tipo', this.tipo);
    formData.append('path', this.path);
    formData.append('id', this.id.toString());
    file.inProgress = true;
    this.contenedoresService.uploadImage(formData).pipe(map(event => {
      switch (event.type) {
        case HttpEventType.UploadProgress:
          file.progress = Math.round(event.loaded * 100 / event.total);
          //console.log(file.progress);
          if(file.progress == 100){
            /*this.toUpload = this.toUpload - 1;
            if(this.toUpload == 0){
              console.log('Images Uploaded');
            }*/
          }
          break;
        case HttpEventType.Response:
          return event;
      }
    }), catchError((error: HttpErrorResponse) => {
      file.inProgress = false;
      return of(`Upload failed: ${file.data.name}`);
    })).subscribe((event: any) => {
      if (typeof (event) === 'object') {
        if(event.body.status === 'ok'){
          this.uploaded++;
          this.checkFilesToUpload();
        }
      }
    });
  }

  checkFilesToUpload(){
    if(this.toUpload === this.uploaded){
      this.dialogRef.close({'upload': true});
    }
  }

}
